// extracted by mini-css-extract-plugin
module.exports = {"loader":"reg-template_2l6GH","alertContainer":"reg-template_1AJjV","contentWrapper":"reg-template_2xAA0"};